import React from 'react';

export const AnimatedDucts = ({ className = "" }) => {
  return (
    <div className={`relative ${className}`}>
      <svg
        viewBox="0 0 800 400"
        className="w-full h-full"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          {/* Gradientes */}
          <linearGradient id="ductGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#1e3a5f" />
            <stop offset="50%" stopColor="#0f172a" />
            <stop offset="100%" stopColor="#1e3a5f" />
          </linearGradient>
          
          <linearGradient id="ductHighlight" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#38bdf8" stopOpacity="0.3" />
            <stop offset="50%" stopColor="#0ea5e9" stopOpacity="0.1" />
            <stop offset="100%" stopColor="#38bdf8" stopOpacity="0.3" />
          </linearGradient>
          
          <linearGradient id="fanGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#0ea5e9" />
            <stop offset="100%" stopColor="#0369a1" />
          </linearGradient>
          
          <linearGradient id="glowGradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#06b6d4" stopOpacity="0" />
            <stop offset="50%" stopColor="#06b6d4" stopOpacity="0.8" />
            <stop offset="100%" stopColor="#06b6d4" stopOpacity="0" />
          </linearGradient>

          {/* Filtro de brilho */}
          <filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur stdDeviation="3" result="coloredBlur" />
            <feMerge>
              <feMergeNode in="coloredBlur" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>

          {/* Padrão de grade para dutos */}
          <pattern id="ductPattern" patternUnits="userSpaceOnUse" width="20" height="20">
            <rect width="20" height="20" fill="transparent" />
            <line x1="0" y1="10" x2="20" y2="10" stroke="#38bdf8" strokeOpacity="0.1" strokeWidth="0.5" />
            <line x1="10" y1="0" x2="10" y2="20" stroke="#38bdf8" strokeOpacity="0.1" strokeWidth="0.5" />
          </pattern>
        </defs>

        {/* Fundo */}
        <rect width="800" height="400" fill="#0f172a" />
        
        {/* Partículas de ar animadas */}
        <g className="air-particles">
          {[...Array(15)].map((_, i) => (
            <circle
              key={i}
              r={Math.random() * 3 + 1}
              fill="#38bdf8"
              opacity="0.6"
            >
              <animate
                attributeName="cx"
                values={`${50 + i * 20};${350 + i * 20};${650};${50 + i * 20}`}
                dur={`${4 + Math.random() * 2}s`}
                repeatCount="indefinite"
              />
              <animate
                attributeName="cy"
                values={`${180 + Math.sin(i) * 30};${200 + Math.cos(i) * 20};${180 + Math.sin(i) * 30}`}
                dur={`${3 + Math.random() * 2}s`}
                repeatCount="indefinite"
              />
              <animate
                attributeName="opacity"
                values="0;0.8;0.4;0.8;0"
                dur={`${4 + Math.random() * 2}s`}
                repeatCount="indefinite"
              />
            </circle>
          ))}
        </g>

        {/* Duto principal horizontal */}
        <g className="main-duct">
          {/* Sombra do duto */}
          <rect x="80" y="165" width="500" height="80" rx="5" fill="#000" opacity="0.3" transform="translate(5, 5)" />
          
          {/* Corpo do duto */}
          <rect x="80" y="165" width="500" height="80" rx="5" fill="url(#ductGradient)" stroke="#1e40af" strokeWidth="2" />
          
          {/* Padrão interno */}
          <rect x="80" y="165" width="500" height="80" rx="5" fill="url(#ductPattern)" />
          
          {/* Reflexo superior */}
          <rect x="85" y="170" width="490" height="15" rx="3" fill="url(#ductHighlight)" />
          
          {/* Linhas de junção */}
          <line x1="180" y1="165" x2="180" y2="245" stroke="#0ea5e9" strokeWidth="1" opacity="0.3" />
          <line x1="280" y1="165" x2="280" y2="245" stroke="#0ea5e9" strokeWidth="1" opacity="0.3" />
          <line x1="380" y1="165" x2="380" y2="245" stroke="#0ea5e9" strokeWidth="1" opacity="0.3" />
          <line x1="480" y1="165" x2="480" y2="245" stroke="#0ea5e9" strokeWidth="1" opacity="0.3" />
        </g>

        {/* Duto vertical (entrada) */}
        <g className="vertical-duct-in">
          <rect x="100" y="80" width="60" height="90" rx="3" fill="url(#ductGradient)" stroke="#1e40af" strokeWidth="2" />
          <rect x="100" y="80" width="60" height="90" rx="3" fill="url(#ductPattern)" />
          <rect x="105" y="85" width="10" height="80" rx="2" fill="url(#ductHighlight)" />
          
          {/* Seta de entrada de ar */}
          <path d="M130 60 L140 75 L135 75 L135 85 L125 85 L125 75 L120 75 Z" fill="#38bdf8" opacity="0.8">
            <animate attributeName="opacity" values="0.4;1;0.4" dur="1.5s" repeatCount="indefinite" />
            <animate attributeName="transform" values="translate(0,0);translate(0,5);translate(0,0)" dur="1.5s" repeatCount="indefinite" />
          </path>
        </g>

        {/* Duto vertical (saída) */}
        <g className="vertical-duct-out">
          <rect x="500" y="240" width="60" height="90" rx="3" fill="url(#ductGradient)" stroke="#1e40af" strokeWidth="2" />
          <rect x="500" y="240" width="60" height="90" rx="3" fill="url(#ductPattern)" />
          <rect x="505" y="245" width="10" height="80" rx="2" fill="url(#ductHighlight)" />
          
          {/* Seta de saída de ar */}
          <path d="M530 350 L540 335 L535 335 L535 325 L525 325 L525 335 L520 335 Z" fill="#38bdf8" opacity="0.8">
            <animate attributeName="opacity" values="0.4;1;0.4" dur="1.5s" repeatCount="indefinite" />
            <animate attributeName="transform" values="translate(0,0);translate(0,5);translate(0,0)" dur="1.5s" repeatCount="indefinite" />
          </path>
        </g>

        {/* Exaustor/Ventilador */}
        <g className="exhaust-fan" transform="translate(620, 205)">
          {/* Carcaça do exaustor */}
          <circle cx="0" cy="0" r="70" fill="#0f172a" stroke="#1e40af" strokeWidth="3" />
          <circle cx="0" cy="0" r="65" fill="url(#ductGradient)" />
          <circle cx="0" cy="0" r="60" fill="#0f172a" stroke="#0ea5e9" strokeWidth="1" />
          
          {/* Grade de proteção */}
          <circle cx="0" cy="0" r="55" fill="none" stroke="#1e3a5f" strokeWidth="2" />
          <line x1="-55" y1="0" x2="55" y2="0" stroke="#1e3a5f" strokeWidth="2" />
          <line x1="0" y1="-55" x2="0" y2="55" stroke="#1e3a5f" strokeWidth="2" />
          <line x1="-39" y1="-39" x2="39" y2="39" stroke="#1e3a5f" strokeWidth="2" />
          <line x1="-39" y1="39" x2="39" y2="-39" stroke="#1e3a5f" strokeWidth="2" />
          
          {/* Pás do ventilador (rotação animada) */}
          <g filter="url(#glow)">
            <g>
              <animateTransform
                attributeName="transform"
                type="rotate"
                from="0 0 0"
                to="360 0 0"
                dur="1s"
                repeatCount="indefinite"
              />
              {/* Pás */}
              <path d="M0 -5 Q20 -25 0 -45 Q-5 -25 0 -5" fill="url(#fanGradient)" />
              <path d="M5 0 Q25 20 45 0 Q25 -5 5 0" fill="url(#fanGradient)" />
              <path d="M0 5 Q-20 25 0 45 Q5 25 0 5" fill="url(#fanGradient)" />
              <path d="M-5 0 Q-25 -20 -45 0 Q-25 5 -5 0" fill="url(#fanGradient)" />
            </g>
          </g>
          
          {/* Centro do ventilador */}
          <circle cx="0" cy="0" r="12" fill="#1e40af" stroke="#38bdf8" strokeWidth="2" />
          <circle cx="0" cy="0" r="6" fill="#0ea5e9">
            <animate attributeName="fill" values="#0ea5e9;#38bdf8;#0ea5e9" dur="2s" repeatCount="indefinite" />
          </circle>
        </g>

        {/* Conexão duto-exaustor */}
        <rect x="575" y="185" width="50" height="40" fill="url(#ductGradient)" stroke="#1e40af" strokeWidth="2" />
        
        {/* Fluxo de ar animado (linhas) */}
        <g className="airflow-lines" opacity="0.6">
          <line x1="100" y1="200" x2="580" y2="200" stroke="url(#glowGradient)" strokeWidth="2" strokeDasharray="10,5">
            <animate attributeName="stroke-dashoffset" values="0;-30" dur="0.5s" repeatCount="indefinite" />
          </line>
          <line x1="100" y1="210" x2="580" y2="210" stroke="url(#glowGradient)" strokeWidth="2" strokeDasharray="10,5">
            <animate attributeName="stroke-dashoffset" values="0;-30" dur="0.6s" repeatCount="indefinite" />
          </line>
        </g>

        {/* Suportes do duto */}
        <g className="supports" fill="#1e3a5f" stroke="#0ea5e9" strokeWidth="1">
          <rect x="150" y="245" width="10" height="40" rx="2" />
          <rect x="300" y="245" width="10" height="40" rx="2" />
          <rect x="450" y="245" width="10" height="40" rx="2" />
        </g>

        {/* Indicadores LED */}
        <g className="led-indicators">
          <circle cx="700" cy="160" r="5" fill="#22c55e">
            <animate attributeName="opacity" values="1;0.3;1" dur="1s" repeatCount="indefinite" />
          </circle>
          <text x="715" y="164" fill="#94a3b8" fontSize="10" fontFamily="sans-serif">ATIVO</text>
        </g>

        {/* Texto decorativo */}
        <text x="400" y="380" textAnchor="middle" fill="#38bdf8" fontSize="14" fontFamily="sans-serif" opacity="0.5">
          Sistema de Ventilação Industrial
        </text>
      </svg>
    </div>
  );
};
